export default __webpack_public_path__ + "898370f6b2aaebc1e0c617440411bff0.woff2";